module.exports = __webpack_public_path__ + "static/media/online1.b5929ba6.svg";